/*
 * ---------------------------------------------------------------------
 * imports
 * ---------------------------------------------------------------------
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    Tooltip,
    IconButton,
    Menu,
    Avatar,
    List,
    ListItem,
    ListItemText,
    Collapse,
} from "@material-ui/core";

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import {
    t
} from "src/shared_modules/i18n";

import AccountMenuItems from "./account-menu-items";

import './account-menu.css';
/*
 * ---------------------------------------------------------------------
 * class AccountMenu
 * ---------------------------------------------------------------------
 *
 */
class AccountMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            anchorMenu : null,
            isListOpen: false,
        }
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
    }

    // used for desktop
    open(event) {
        this.setState({anchorMenu: event.currentTarget });
    }

    // used for mobile
    toggle(event) {
        this.setState({isListOpen: !this.state.isListOpen });
    }

    // used desktop and mobile
    close() {
        if( this.props.mobile ) {
            this.setState({isListOpen: false });
            if ( this.props.onLeave )
                this.props.onLeave();
        } else {
            this.setState({anchorMenu: null });
        }
    }

    renderAvatar() {
        if( this.props.user.type === "wechatanonym" )
            return null;

        const me = this.props.user.profile;
        if( !me )
            return null;

        let alt = me.firstname +" "+ me.lastname;

        let cssAva = "main-nav-avatar";
        if( this.props.mobile) {
            cssAva += " mobile";
        } else {
            cssAva += " desktop";
        }

        if( !me.thumbnail ) {
            let initials = me.firstname.charAt(0) + me.lastname.charAt(0);
            return(<Avatar className={cssAva}>{initials}</Avatar>);
        }
        let url = me.thumbnail;
        /*if( !url.startsWith("http") )
            url = this.props.meaconfig.baseUrl + person.thumbnail;*/

        return(<Avatar className={cssAva} alt={alt} src={url} />)
    }

    renderMobile() {
        const me = this.props.user.profile;
        if( !me )
            return null;


        let label = me.firstname +" "+ me.lastname;

        if( this.props.user.type === "wechatanonym" )
            label = "WeChat Anonym";

        return (<React.Fragment>
                    <li className="main-nav-avatar-container">
                    { this.renderAvatar() }
                    </li>
                    <ListItem button  onClick={this.toggle} >
                        <ListItemText primary={label} />
                         {this.state.isListOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </ListItem>
                    <Collapse in={this.state.isListOpen} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <AccountMenuItems themedStyle={this.props.themedStyle} mobile closeHandler={this.close} />
                        </List>
                    </Collapse>
            </React.Fragment>);
    }

    renderDesktop() {
        let colorAccount = "inherit";
        if( Boolean(this.state.anchorMenu) )
            colorAccount = "secondary";

        return (<React.Fragment>
                    <Tooltip title={t("main-nav.account")}>
                        <IconButton aria-label="account" onClick={this.open}>
                            <AccountCircleIcon color={colorAccount} />
                        </IconButton>
                    </Tooltip>
                    <Menu id="user-menu"
                            anchorEl={this.state.anchorMenu}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            getContentAnchorEl={ null }
                            anchorReference="anchorEl"
                            open={Boolean(this.state.anchorMenu)}
                            onClose={this.close}
                        >
                        <AccountMenuItems themedStyle={this.props.themedStyle} closeHandler={this.close} />
                    </Menu>
            </React.Fragment>);
    }

    render() {
        // no plazz convention hide it
        if( !this.props.event.hasPlazzConvention )
            return (null);

        if( !this.props.user.loggedIn )
            return (null);


        return (<React.Fragment>
                { this.props.mobile && this.renderMobile() }
                { !this.props.mobile && this.renderDesktop() }
            </React.Fragment>);
    }

}
/*
 * ---------------------------------------------------------------------
 * AccountMenu prop Types
 * ---------------------------------------------------------------------
 */
AccountMenu.propTypes = {
    user : PropTypes.object,
    event : PropTypes.object,
};
/*
 * ---------------------------------------------------------------------
 * AccountMenu Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        user : state.user,
        event : state.event,
        currentLang : state.system.currentLang,
    };
};

const mapDispatchToProps = {
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(AccountMenu);
